module.exports = __webpack_public_path__ + "img/cz.49044310.svg";